import styled from "styled-components";
import { Colors } from "../../../../values/colors";

export const ModalBackdrop = styled.div`
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
`;

export const ModalContainer = styled.div`
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 8px 48px rgba(0, 0, 0, 0.22);
  width: 480px;
  max-width: 100%;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const ModalHeader = styled.div`
  padding: 16px 20px 14px;
  border-bottom: 1px solid ${Colors.ultraLightGray2};
  flex-shrink: 0;
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const HeaderTitle = styled.h2`
  font-size: 15px;
  font-weight: 700;
  color: ${Colors.primaryColor};
  margin: 0;
  display: flex;
  align-items: center;
  gap: 7px;
`;

export const CloseBtn = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: ${Colors.lightGray};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.15s;
  &:hover {
    background: ${Colors.ultraLightGray2};
    color: ${Colors.blueGray};
  }
`;

export const ModalBody = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 16px 20px 20px;
`;

/* ── Survey Legend ── */
export const SurveyLegend = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin-bottom: 14px;
`;

export const LegendItem = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 12px 14px;
  border-radius: 10px;
  background: ${({ bg }) => bg || Colors.ultraLightGray3};
`;

export const LegendItemHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const LegendDot = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${({ color }) => color};
  flex-shrink: 0;
`;

export const LegendName = styled.span`
  font-size: 13px;
  font-weight: 700;
  color: ${({ color }) => color};
  line-height: 1.3;
`;

export const LegendDate = styled.span`
  font-size: 11px;
  color: ${Colors.blueMist};
  padding-left: 18px;
`;

/* ── Download Buttons ── */
export const DownloadOutlineBtn = styled.button`
  width: 100%;
  padding: 9px;
  border-radius: 8px;
  background: ${Colors.ultraLightGray3};
  color: ${Colors.primaryPurple};
  font-size: 13px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  margin-bottom: 18px;
  transition: border-color 0.15s, color 0.15s, background 0.15s;
  &:hover {
    border-color: ${Colors.primaryPurple};
    background: rgba(93, 61, 237, 0.03);
  }
`;

export const DownloadFilledBtn = styled.button`
  width: 100%;
  padding: 12px;
  border-radius: 8px;
  border: none;
  background: ${Colors.primaryPurple};
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  margin-top: 18px;
  transition: opacity 0.2s;
  &:hover {
    opacity: 0.88;
  }
`;

/* ── Section ── */
export const Section = styled.div`
  margin-bottom: 18px;
`;

export const SectionTitle = styled.h3`
  font-size: 14px;
  font-weight: 700;
  color: ${Colors.primaryColor};
  margin: 0 0 10px;
`;

/* ── Análise Geral ── */
export const AnalysisTable = styled.div`
  border: 1px solid ${Colors.ultraLightGray2};
  border-radius: 8px;
  overflow: hidden;
`;

export const AnalysisHeader = styled.div`
  display: grid;
  grid-template-columns: 1fr 90px 90px 80px;
  background: ${Colors.ultraLightGray3};
  padding: 8px 12px;
  gap: 4px;
`;

export const AnalysisHeaderCell = styled.span`
  font-size: 10px;
  font-weight: 700;
  color: ${({ color }) => color || Colors.blueMist};
  text-align: center;
  line-height: 1.3;
  &:first-child {
    text-align: left;
  }
`;

export const AnalysisRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 90px 90px 80px;
  background: ${Colors.ultraLightGray3};
  padding: 10px 12px;
  gap: 4px;
  border-top: 1px solid ${Colors.ultraLightGray2};
  align-items: center;
`;

export const AnalysisLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: ${Colors.blueGray};
  font-weight: 500;
`;

export const AnalysisValue = styled.span`
  font-size: 15px;
  font-weight: 700;
  color: ${({ color }) => color || Colors.primaryPurple};
  text-align: center;
`;

export const VariationCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  font-size: 12px;
  font-weight: 700;
  color: ${({ color }) => color};
`;

/* ── Termômetro ── */
export const ThermoTable = styled.div`
  border: 1px solid ${Colors.ultraLightGray2};
  border-radius: 8px;
  overflow: hidden;
`;

export const ThermoHeader = styled.div`
  display: grid;
  grid-template-columns: 1fr 72px 72px 72px 72px;
  background: ${Colors.ultraLightGray3};
  padding: 8px 12px;
  gap: 4px;
`;

export const ThermoHeaderCell = styled.span`
  font-size: 10px;
  font-weight: 700;
  color: ${({ color }) => color || Colors.blueMist};
  text-align: center;
  line-height: 1.3;
  &:first-child {
    text-align: left;
  }
`;

export const ThermoRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 72px 72px 72px 72px;
  background: ${Colors.ultraLightGray3};
  padding: 10px 12px;
  gap: 4px;
  border-top: 1px solid ${Colors.ultraLightGray2};
  align-items: center;
`;

export const ThermoLabel = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: ${Colors.blueGray};
`;

export const ThermoValue = styled.span`
  font-size: 18px;
  font-weight: 700;
  color: ${({ color }) => color};
  text-align: center;
`;

export const NivelBadge = styled.span`
  display: inline-block;
  padding: 3px 8px;
  border-radius: 99px;
  background: ${({ bg }) => bg};
  color: ${({ color }) => color};
  font-size: 10px;
  font-weight: 700;
  text-align: center;
  white-space: nowrap;
`;

/* ── Comparação por Categoria ── */
export const CatCompHeader = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0;
  margin-bottom: 8px;
  padding-right: 14px;
`;

export const CatCompHeaderLabel = styled.span`
  font-size: 10px;
  font-weight: 700;
  color: ${({ color }) => color};
  width: 72px;
  text-align: center;
  line-height: 1.3;
`;

export const CatCompHeaderArrowSpacer = styled.div`
  width: 26px;
  flex-shrink: 0;
`;

export const CategoryCard = styled.div`
  border: 1px solid ${Colors.ultraLightGray};
  border-radius: 10px;
  padding: 11px 14px;
  margin-bottom: 7px;
  display: flex;
  background: ${Colors.ultraLightGray3};
  align-items: center;
  gap: 10px;
`;

export const CategoryIconWrap = styled.div`
  width: 34px;
  height: 34px;
  border-radius: 8px;
  background: ${({ bg }) => bg || Colors.ultraLightGray3};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const CategoryName = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: ${Colors.blueGray};
  flex: 1;
  line-height: 1.3;
`;

export const CategoryValues = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
`;

export const CategoryAvgsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const CatAvg = styled.span`
  font-size: 19px;
  font-weight: 700;
  color: ${({ color }) => color};
  width: 72px;
  text-align: center;
  flex-shrink: 0;
  background: ${Colors.white};
  border-radius: 6px;
`;

export const CatArrowIcon = styled.span`
  color: ${Colors.lightGray};
  font-size: 14px;
  line-height: 1;
  width: 26px;
  text-align: center;
  flex-shrink: 0;
`;

export const DeltaRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const DeltaPill = styled.span`
  font-size: 11px;
  font-weight: 700;
  color: ${({ color }) => color};
  display: flex;
  align-items: center;
  gap: 2px;
`;

export const RiskLabel = styled.span`
  font-size: 10px;
  font-weight: 700;
  color: ${({ color }) => color};
  background: ${({ bg }) => bg};
  padding: 2px 7px;
  border-radius: 99px;
`;

/* ── PGR Section ── */
export const PGRGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
`;

export const PGRCard = styled.div`
  border: 2px solid ${({ borderColor }) => borderColor};
  border-radius: 10px;
  padding: 12px;
`;

export const PGRCardLabel = styled.div`
  font-size: 9px;
  font-weight: 700;
  color: ${({ color }) => color};
  text-transform: uppercase;
  letter-spacing: 0.6px;
  margin-bottom: 4px;
`;

export const PGRSurveyName = styled.div`
  font-size: 11px;
  font-weight: 600;
  color: ${Colors.blueGray};
  margin-bottom: 12px;
  line-height: 1.4;
`;

export const PGRStats = styled.div`
  display: flex;
  gap: 0;
  margin-bottom: 10px;
  justify-content: space-between;
`;

export const PGRStat = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1px;
  flex: 1;
`;

export const PGRStatValue = styled.span`
  font-size: 20px;
  font-weight: 700;
  color: ${Colors.primaryColor};
  line-height: 1.1;
`;

export const PGRStatLabel = styled.span`
  font-size: 9px;
  color: ${Colors.blueMist};
  text-align: center;
`;

export const PGRProgress = styled.div`
  margin-top: 4px;
`;

export const PGRProgressLabel = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 10px;
  color: ${Colors.blueMist};
  margin-bottom: 3px;
`;

export const PGRProgressBar = styled.div`
  height: 5px;
  border-radius: 99px;
  background: ${Colors.ultraLightGray2};
  overflow: hidden;
`;

export const PGRProgressFill = styled.div`
  height: 100%;
  border-radius: 99px;
  background: ${({ color }) => color};
  width: ${({ pct }) => pct}%;
  transition: width 0.4s ease;
`;

/* ── Select Step ── */
export const SelectTitle = styled.h3`
  font-size: 15px;
  font-weight: 700;
  color: ${Colors.primaryColor};
  margin: 0 0 4px;
`;

export const SelectSubtitle = styled.p`
  font-size: 13px;
  color: ${Colors.blueMist};
  margin: 0 0 16px;
  line-height: 1.5;
`;

export const SelectSurveyList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 18px;
  max-height: 320px;
  overflow-y: auto;
  padding-right: 2px;
`;

export const SelectSurveyItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 11px 12px;
  border-radius: 8px;
  border: 1.5px solid ${({ selected }) => (selected ? Colors.primaryPurple : Colors.ultraLightGray)};
  background: ${({ selected }) => (selected ? "rgba(93,61,237,0.04)" : "#fff")};
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;
  &:hover {
    border-color: ${({ selected }) => (selected ? Colors.primaryPurple : Colors.lightGray)};
    background: ${({ selected }) => selected ? "rgba(93,61,237,0.04)" : Colors.ultraLightGray3};
  }
`;

export const SelectRadio = styled.div`
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid ${({ selected }) => (selected ? Colors.primaryPurple : Colors.lightGray)};
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border-color 0.15s;
  &::after {
    content: "";
    display: ${({ selected }) => (selected ? "block" : "none")};
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${Colors.primaryPurple};
  }
`;

export const SelectSurveyInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const SelectSurveyTitle = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: ${Colors.blueGray};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const SelectSurveyDate = styled.div`
  font-size: 11px;
  color: ${Colors.blueMist};
  margin-top: 2px;
`;

export const SelectStatusBadge = styled.span`
  font-size: 10px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 99px;
  background: ${({ bg }) => bg};
  color: #fff;
  white-space: nowrap;
  flex-shrink: 0;
`;

export const ConfirmSelectBtn = styled.button`
  width: 100%;
  padding: 11px;
  border-radius: 8px;
  border: none;
  background: ${({ disabled }) => (disabled ? Colors.ultraLightGray : Colors.primaryPurple)};
  color: ${({ disabled }) => (disabled ? Colors.lightGray : "#fff")};
  font-size: 14px;
  font-weight: 700;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  transition: opacity 0.2s;
  &:hover:not(:disabled) {
    opacity: 0.88;
  }
`;

export const EmptySelectMsg = styled.div`
  text-align: center;
  padding: 24px 0;
  font-size: 13px;
  color: ${Colors.blueMist};
`;

/* -- Aviso de Pesquisa em Andamento --*/
export const OngoingSurveyAlert = styled.div`
  background: rgba(255, 163, 10, 0.12);
  border-left: 6px solid rgb(255, 163, 10);
  padding: 12px;
  margin-bottom: 20px;
  gap: 10px;
`;

export const OngoingSurveyAlertTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 15px;
  font-weight: 700;
  color: #D3852C;
`

export const OngoingSurveyText = styled.div`
  font-size: 13px;
  color: ${Colors.black};
`;

export const CardDivider = styled.hr`
  border: none;
  border-top: 1px solid #FFD181;
  margin: 10px 0px;
`;

export const OngoingSurveyDate = styled.div`
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 10px;
  color: ${Colors.black};
`
